const options = {
    fix: true
};
export default options;
